import { Peer } from "peerjs"
import { io } from "socket.io-client";

export default class NeoRtc {
  constructor(userId){

    // user name for meeting display
    this.userName = null

    // meeting participants
    this.meetingParticipants = []

    this.toggleInfoLastTarget = ''

    this.meetingObject = null

    this.isScreenShared = false
    
    // meeting or video call title
    this.title = 'Video Call'

    // RTC mode -> meet | call
    this.mode = 'call'

    // meeting or video call userName
    this.userName = ''

    // meeting or video call memberCode
    this.memberCode = null

    // default meeting MediaStream constraints
    this.meetingConstraints = {
      video: true,
      audio: true
    }

    // MediaStream from peer call
    this.callStream = null

    // MediaStream from own call
    this.ownCallStream = null

    // MediaStream from share screen
    this.ownScreenStream = null

    // meeting name from name fields on chats table
    this.meetingName = ''

    // RTC userId from contact id
    this.userId = userId

    // Voice call or video call target contact data
    this.targetContact = null

    // Voice call or video call target group
    this.targetGroup = null

    // MediaStream comes from call.answer
    this.targetStreamMedia = null

    // ringtone
    this.callingAudio = new Audio()
    this.callingAudioTimeout = null

    this.peer = null

    // replay ringtone after ringtone stop
    this.callingAudio.onended = fn => {
      if(this.callingAudioTimeout) clearTimeout(this.callingAudioTimeout)

      this.callingAudioTimeout = setTimeout(to => {
        this.callingAudio.play()
      }, 3000)
    }

    // socket.io initialization
    const URL = process.env.MIX_SOCKET_PROTOCOL + '://' + process.env.MIX_SOCKET_HOST + ':' + process.env.MIX_SOCKET_PORT
    this.socket = io(URL, {
      secure: process.env.MIX_SOCKET_PROTOCOL == 'https' ? true : false,
      reconnection: false,             // default setting at present
      // reconnectionDelay: 1000,        // default setting at present
      // reconnectionDelayMax : 5000,    // default setting at present
      // reconnectionAttempts: Infinity  // default setting at present
    })

    // peerjs initialization
    this.peer = new Peer(undefined, {
      host: process.env.MIX_SOCKET_HOST,
      port: process.env.MIX_PEERJS_PORT,
      path: process.env.MIX_PEERJS_PATH
    })

    const tryReconnect = () => {
      console.log('trying to reconnect')
      setTimeout(() => {
        this.socket.io.open(async (err) => {
          if (err) {
            tryReconnect();
          }
          else
          {
            if(this.peer.destroyed)
            {
              // reinitialized peer
              this.peer = new Peer(undefined, {
                host: process.env.MIX_SOCKET_HOST,
                port: process.env.MIX_PEERJS_PORT,
                path: process.env.MIX_PEERJS_PATH
              })
            }
            else
            {
              this.peer.reconnect()
            }
            // console.log(this.peer)
            // this.socket.emit('join-online', {peerId: this.peer.id, userId: userId}, false)
          }
        });
      }, 2000);
    }
    
    this.socket.io.on("close", tryReconnect);

    tryReconnect()

    /**
     * after we got peerId, send it into socket server
     * @param peerId
     * @action emit socket, send join-online signal with peerId and userId parameter
     * @callback false
     */
    this.peer.on('open', peerId => {
      // get user id
      this.socket.emit('join-online', {peerId: peerId, userId: userId}, false)
    })

    /**
     * trigger after peer.call() executed
     */
    this.peer.on('call', async call => { 

      console.log('someone calling', call)

      // answering the call and send our MediaStream
      call.answer(this.streamMedia)

      // get caller metadata
      var metadata = call.metadata
      
      // get caller MediaStream
      call.on('stream', userVideoStream => {

        this.targetStreamMedia = userVideoStream
        let video = true
        let id = null

        if(this.mode == 'call')
        {
          video = this.targetContact.video
          id = this.targetContact.id
          if(this.targetContact.video)
          {
            // for videoCallInterface
            metadata.user = this.targetContact.full_name
          }
          else
          {
            // Voice call only
            const callBodyString = $('.call-body').html()
            if(!callBodyString.includes('Connected'))
            {
              $('.call-body').html('Connected')
              this.updateCallFoot('connected') 
            }
          }
        }
        else if(this.mode == 'call group')
        {
          // const user = await window.chatFunction.value.getContact()
          // metadata.user = user.full_name
          id = metadata.id
        }
        else
        {
          id = call.peer
        }
        
        // put MediaStream into call interface
        this.appendStreamMedia(userVideoStream, video, id, metadata)
      })

      call.on('close', () => {
        // video.remove()
      })

      // target call stream for public access 
      this.callStream = call

    })

    /**
     * get signal calling from socket server
     */
    this.socket.on('calling', async data => {

      // set and play ringtone audio
      if(process.env.MIX_RING_AUDIO)
      {
        this.callingAudio.src = process.env.MIX_RING_AUDIO
        this.callingAudio.play()
      }

      // save caller data
      this.targetContact = data
      this.callInterface('Incoming call...', true)

    })
    
    /**
     * get signal calling from socket server
     */
    this.socket.on('calling-group', async data => {

      this.mode = 'call group'
      this.meetingConstraints.video = data.video

      // set and play ringtone audio
      if(process.env.MIX_RING_AUDIO)
      {
        this.callingAudio.src = process.env.MIX_RING_AUDIO
        this.callingAudio.play()
      }

      // save caller data
      this.targetGroup = data
      this.callInterface('Incoming call...', true)

    })

    /**
     * when target accepted the call
     * and closed all connection to same user
     * sample case : 
     * browser have multiple tabs or windows from a user
     * so, each user will get the ringtone
     */
    this.socket.on('call-accepted', () => {
      // turn off the ringtone
      this.killMedia()

      $('.call-body').html(`Call accepted.`)

      // hide the call interface
      setTimeout( e => {
        const elem = '.video-call-interface, .call-interface'
        $(elem).fadeOut(300, fn => {
          $(elem).remove()
        })
      }, 2000)
    })

    /**
     * got this after target user accept the call
     */
    this.socket.on('call-answered', async data => {
      // get peerId
      const targetPeerId = data.targetPeerId

      // get datetime from socket server
      const datetime = data.datetime

      // stop the ringtone
      this.stopingAudio()

      let metadata = {}
      let video = false
      let id = 0
      let userName = ''

      if(this.mode == 'call')
      {
        $('.call-body').html(`${this.targetContact.full_name} Connecting...`)
        
        video = this.targetContact.video
        id = this.targetContact.id
        userName = this.targetContact.full_name
        if(this.targetContact.video)
        {
          // set meta data if session is video call
          metadata = {
            metadata: {
              user: this.userId,
              video: this.videoStatus(),
              audio: this.audioStatus(),
            }
          }
        }
      }
      else if(this.mode == 'call group')
      {
        video = this.targetGroup.video
        const user = await window.chatFunction.value.getContact()
        id = data.userId
        userName = data.userName
        metadata = {
          metadata: {
            id: user.id,
            user: user.full_name,
            video: this.videoStatus(),
            audio: this.audioStatus(),
          }
        }
      }

      // call target via peerjs
      const call = this.peer.call(targetPeerId, this.streamMedia, metadata)

      // when we got the target stream
      call.on('stream', userVideoStream => {
        // if session is not video call
        // just update the interface status
        
        if(this.mode == 'call')
        {
          if(!this.targetContact.video)
          {
            const callBodyString = $('.call-body').html()
            if(!callBodyString.includes('Connected'))
            {
              this.targetStreamMedia = userVideoStream
              $('.call-body').html('Connected')
              this.updateCallFoot('connected')
            }
          }
        }

        // append MediaStream to browser
        this.appendStreamMedia(userVideoStream, this.mode == 'call' ? video : true, id, {
          user: userName,
          video: video,
          audio: true
        })
      })

      // If they leave, remove their video
      call.on('close', () => {
        // video.remove()
      })

      this.ownCallStream = call
    })

    /**
     * if target rejected the call
     */
    this.socket.on('call-rejected', () => {
      console.log('call rejected')
      // turn off the ringtone
      this.killMedia()
      if(this.mode == 'call')
      {
        $('.call-body').html(`${this.targetContact.full_name} rejected the call.`)
        // hide call interface
      }
      setTimeout( e => {
        const elem = '.video-call-interface, .call-interface'
        $(elem).fadeOut(300, fn => {
          $(elem).remove()
        })
      }, 2000)

      // if(this.mode == 'call-group')
      // {
      //   // hide call interface
      //   setTimeout( e => {
      //     const elem = '.video-call-interface, .call-interface'
      //     $(elem).fadeOut(300, fn => {
      //       $(elem).remove()
      //     })
      //   }, 2000)
      // }

    })

    /**
     * got this when target user is typing
     * and update the info status 
     */
    this.socket.on('bc-typing', (data) => {
      const status = data.status
      const contact = data.contactId

      $('.active-status.user-'+contact).html(status ? 'typing...' : 'Active')
    })

    /**
     * when target send message to us
     * put new message to chat window
     */
    this.socket.on('bc-message', (data) => {
      const contact = data.contactId
      const chat = data.data

      if(window.chatFunction)
      {
        if(contact==this.userId || (this.targetContact && this.targetContact.id == contact))
        {
          window.chatFunction.value.pushNewChat(chat)
        }
  
        window.chatFunction.value.loadChatGroup()
      }

    })
    
    /**
     * when target send message to group
     * put new message to chat window
     */
    this.socket.on('bc-message-group', (data) => {
      const groupId = data.groupId
      const chat = data.data

      if(window.chatFunction)
      {
        if(this.targetGroup && this.targetGroup.id == groupId)
        {
          window.chatFunction.value.pushNewChat(chat)
        }
  
        window.chatFunction.value.loadChatGroup(false, 'group')
      }

    })

    /**
     * when user send message to the meeting
     * put new message to chat window
     */
    this.socket.on('bc-meeting-message', (data) => {

      this.pushNewMeetingMessage(data)

    })

    /**
     * when target ended the call
     */
    this.socket.on('call-ended', () => {
      this.endedCall('.btn-call-ended, .btn-call-ended-phone')
    })

    /**
     * when target leave meeting
     */
    this.socket.on('leave-meeting', (data) => {
      // remove video
      $(`video#user-${data.peerId}`).parent().remove()
    })
    
    /**
     * when target leave call group
     */
    this.socket.on('leave-call-group', (data) => {
      // remove video
      $(`video#user-${data.userId}`).parent().remove()
    })

    /**
     * when target turn camera on or off
     */
    this.socket.on('toggle-cam', (data) => {
      const userId = this.mode == 'meet' ? data.peerId : data.userId
      this.toggleVideoEffect(userId, data.status)
    })

    /**
     * when target turn mic on or off
     */
    this.socket.on('toggle-mic', (data) => {
      const userId = this.mode == 'meet' ? data.peerId : data.userId
      this.toggleAudioEffect(userId, data.status)
    })

    /**
     * refresh meeting participants
     */
    this.socket.on('bc-participant', (data) => {
      this.meetingParticipants = data
      this.refreshParticipantLists()
    })

    /**
     * when someone join the meeting
     */
    this.socket.on('join-meeting', async (data) => {
 
      // create meta data which will received by new join
      const params = {metadata:{
          user: this.userName,
          video: this.videoStatus(),
          audio: this.audioStatus(),
        }
      }

      // call the new join
      const call = this.peer.call(data.peerId, this.streamMedia, params)

      // append the new join MediaStream into meeting interface
      call.on('stream', userVideoStream => {
        this.appendStreamMedia(userVideoStream, true, data.peerId, {
          user: data.user,
          video: data.video,
          audio: data.audio
        })
      })

      // If they leave, remove their video
      call.on('close', () => {
        // video.remove()
      })

      this.callStream = call
    })
  }

  /**
   * fill username modal if guest user
   */
  userNameModal(){
    let html = `<div class="modal fade" tabindex="-1" id="modalMeetingUserName">
      <div class="modal-dialog" role="document">
        <div class="modal-content">            
          <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close">                
            <em class="icon ni ni-cross"></em>            
          </a>            
          <div class="modal-header">               
            <h5 class="modal-title">Meeting Username</h5>            
          </div>            
          <div class="modal-body">                
            <label for="">Please input your name</label>
            <input type="text" class="form-control" id="meetingUsername" onkeyup="neoRtc.userName=this.value">
          </div>            
          <div class="modal-footer bg-light">                
            <button class="btn btn-primary btn-submit" onclick="neoRtc.joinMeeting()">Join Meeting</button>
          </div>        
        </div>    
      </div>
    </div>`

    $("body").append(html)
    setTimeout(e => {
      $('#modalMeetingUserName').modal('show');

      $('#modalMeetingUserName').on('hide.bs.modal', e => {
        if(!this.userName)
        {
          window.location.reload()
        }
      })
    }, 500)
  }

  /**
   * when we join meeting
   */
  async joinMeeting(){
    if(!this.userName)
    {
      // show username input prompt
      this.userNameModal()
    }
    else
    {
      if($('#modalMeetingUserName').hasClass('show'))
      {
        $('#modalMeetingUserName').modal('hide');
      }
      // get MediaStream
      this.streamMedia = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true
      })
  
      // set the audio and video status
      this.streamMedia.getVideoTracks()[0].enabled = this.meetingConstraints.video
      this.streamMedia.getAudioTracks()[0].enabled = this.meetingConstraints.audio
  
      // broadcast to socket server because we are the new join
      this.socket.emit('join-meeting', {userId:this.userId,userName:this.userName,meetingName:this.meetingName,...this.meetingConstraints}, (response) => {

        this.meetingParticipants = response.meetingParticipants
        this.refreshParticipantLists()

        // meeting time for meeting interface
        this.runTime(response.datetime)
  
        // user for meeting interface
        this.userName = response.user
  
        // append MediaStream to meeting interface
        this.appendStreamMedia(false, true, this.userId, {
          user: this.userName,
          ...this.meetingConstraints
        })
      })
    }
  }

  /**
   * call action interface
   * show after someone make a call
   */
  callActionInterface(status){
    if(status == 'caller' || status == 'connected')
    {
      return `<button class="btn btn-danger btn-call-ended-phone" onclick="neoRtc.endedCall(this)">Ended Call</button>`
    }

    if(status == 'target')
    {
      return `<button class="btn btn-danger btn-call-reject" onclick="neoRtc.rejectCall(this)">Reject</button>
      <button class="btn btn-success btn-call-accept mr-2" onclick="neoRtc.acceptCall(this)">Accept</button>`
    }
  }

  /**
   * show after someone make a call
   */
  callInterface(callText, needAccept = false){
    const contact = this.targetContact || this.targetGroup
    let actionButton = this.callActionInterface('caller')
    
    if(needAccept)
    {
      actionButton = this.callActionInterface('target')
    }

    $("body").append(`<div class="call-interface d-flex align-items-center justify-content-between">
      <div class="call-contact user-avatar ${this.targetGroup ? 'd-none' : ''}">
        ${ this.targetContact ? '<img src="'+contact.avatar.thumbnail+'">' : ''}
      </div>
      <div class="call-body">
        <span class="call-description">${callText}</span>
        <span style="font-size: smaller">Not answering yet</span>
      </div>
      <div class="call-foot text-center">
      ${actionButton}
      </div>
      <div class="audio-stream"></div>
    </div>
    `);
  }

  /**
   * show when meeting or video call
   */
  videoCallInterface(asString = false){
    const videoIcon = this.meetingConstraints.video ? '' : '-off'
    const audioIcon = this.meetingConstraints.audio ? '' : '-off'
    let html = `<div class="video-call-interface p-8">
                  <div class="vc-head d-flex justify-content-between">
                    <img src="/modules/chat/img/logo-light.png" class="neo-logo" style="height:32px">
                    <img src="/modules/chat/img/powered-connect.png" class="connect-logo" style="height:32px">
                  </div>
                  <div class="vc-body-container d-flex align-items-center justify-content-center overflow-auto">
                    <div class="vc-body py-3 d-flex flex-wrap justify-content-center gap-2 m-auto"></div>
                  </div>
                  <div class="vc-foot d-sm-flex justify-content-between align-items-center">
                    <div class="timer text-white flex-even">
                      <b><span class="neo-clock">00:00</span> | ${this.title}</b>
                    </div>
                    <div class="call-features d-sm-flex justify-content-center gap-1 align-items-center flex-even" style="height:35px">
                      <button class="btn btn-secondary btn-icon btn-round" onclick="neoRtc.toggleVideo(this)"><em class="icon ni ni-video${videoIcon}"></em></button>
                      <button class="btn btn-secondary btn-icon btn-round" onclick="neoRtc.toggleAudio(this)"><em class="icon ni ni-mic${audioIcon}"></em></button>
                      <button class="btn btn-danger btn-call-ended" onclick="neoRtc.endedCall(this)" style="height:42px"><em class="icon ni ni-call-fill" style="rotate: 135deg"></em></button>
                      <button class="btn btn-secondary btn-icon btn-round" onclick="neoRtc.screenShare(this)"><em class="icon ni ni-monitor"></em></button>
                      <button class="btn btn-secondary btn-icon btn-round" onclick="neoRtc.toggleFullscreen(this)"><em class="icon ni ni-expand"></em></button>
                    </div>
                    <div class="call-side-features d-sm-flex justify-content-end gap-1 align-items-center flex-even">
                      <button class="btn btn-default btn-icon" onclick="neoRtc.toggleInfo('detail')"><em class="icon ni ni-info"></em></button>
                      <button class="btn btn-default btn-icon ${['call','call group'].includes(this.mode) ? 'd-none' : ''}" onclick="neoRtc.toggleInfo('participant')"><em class="icon ni ni-users"></em></button>
                      <button class="btn btn-default btn-icon ${['call','call group'].includes(this.mode) ? 'd-none' : ''}" onclick="neoRtc.toggleInfo('chat')"><em class="icon ni ni-chat"></em></button>
                    </div>
                  </div>
                </div><style>.flex-even{flex: 1;}#user-${this.userId}{-webkit-transform: scaleX(-1);transform: scaleX(-1);}.user-video .user-video-element {border-radius: 1em;overflow: hidden;}</style>
    `

    if(this.meetingObject)
    {
      html += `<div class="meeting-info bg-light p-4">
                <div class="detail-panel info-item d-none">
                  <div class="info-title"><h4>${this.title}</h4></div>
                  <hr>
                  <span class="title">Meeting Date</span>
                  <div class="info-description">
                    <ul class="list-unstyled">  
                      <li><em class="icon ni ni-clock"></em> ${this.meetingObject.created_at}</li>    
                    </ul>
                  </div>
                  <hr>
                  <span class="title">Access Information</span>
                  <div class="info-description">
                    <ul class="list-unstyled">  
                      <li><a href="javascript:void(0)" onclick="navigator.clipboard.writeText('${this.meetingObject.url}');">${this.meetingObject.url}</a></li>    
                    </ul>
                  </div>
                </div>`
      html += ` <div class="chat-panel info-item d-none">
                  <div class="info-title"><h4>Chat</h4></div>
                  <hr>
                  <div class="info-description"></div>
                  <div class="chat-form">
                    <div class="form-control-wrap">
                      <div class="input-group">
                        <input type="text" id="meeting-message" class="form-control" onkeydown="neoRtc.meetingMessageKeyDown()" placeholder="Your message here...">
                        <div class="input-group-append">
                          <button class="btn btn-outline-primary btn-dim" onclick="neoRtc.sendMeetingMessage()"><em class="icon ni ni-send-alt"></em></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="participant-panel info-item d-none">
                  <div class="info-title"><h4>Participants</h4></div>
                  <hr>
                  <div class="info-description"></div>
                </div>
              </div>`
    }
    if(asString) return html
    $("body").append(html)
  }

  meetingMessageKeyDown(){
    // Get the code of pressed key
    const keyCode = event.which || event.keyCode

    // 13 represents the Enter key
    if (keyCode === 13) {
        // Don't generate a new line
        event.preventDefault();

        this.sendMeetingMessage()
    }
  }

  sendMeetingMessage(){
    if($('#meeting-message').val() == '') return

    const content = $("#meeting-message").val()

    this.socket.emit('bc-meeting-message', {
      userId:this.userId,
      userName:this.userName,
      meetingName:this.meetingName,
      content: content
    })

    this.pushNewMeetingMessage({
      name: this.userName,
      content: content
    })

    $("#meeting-message").val('')
  }

  /**
   * toggle meeting or video call to fullscreen
   */
  toggleFullscreen(btn){
    if(document.fullscreenElement)
    {
      document.exitFullscreen()
      btn.innerHTML = '<em class="icon ni ni-expand">'
    }
    else
    {
      document.querySelector('.video-call-interface').requestFullscreen()
      btn.innerHTML = '<em class="icon ni ni-shrink">'
    }
  }

  /**
   * our video status
   */
  videoStatus(){
    if(this.callStream)
    {
      return this.callStream.peerConnection.getLocalStreams()[0].getVideoTracks().length ? this.callStream.peerConnection.getLocalStreams()[0].getVideoTracks()[0].enabled : false     
    }

    return this.streamMedia.getVideoTracks().length ? this.streamMedia.getVideoTracks()[0].enabled : false
  }
  
  /**
   * our audio status
   */
  audioStatus(){
    if(this.callStream)
    {
      return this.callStream.peerConnection.getLocalStreams()[0].getAudioTracks().length ? this.callStream.peerConnection.getLocalStreams()[0].getAudioTracks()[0].enabled : false
    }

    return this.streamMedia.getAudioTracks().length ? this.streamMedia.getAudioTracks()[0].enabled : false
  }

  /**
   * toggle video on or off
   */
  toggleVideo(btn){
    let status = null
    if(this.callStream)
    {
      this.callStream.peerConnection.getLocalStreams()[0].getTracks()[1].enabled = !this.callStream.peerConnection.getLocalStreams()[0].getTracks()[1].enabled
      status = this.callStream.peerConnection.getLocalStreams()[0].getTracks()[1].enabled      
    }
    else
    {
      this.streamMedia.getVideoTracks()[0].enabled = !this.streamMedia.getVideoTracks()[0].enabled
      status = this.streamMedia.getVideoTracks()[0].enabled
    }

    this.toggleVideoEffect(this.userId, status)

    this.socket.emit('toggle-cam', {
      userId: this.userId,
      meetingName: this.meetingName,
      status: status
    })
    btn.innerHTML = status ? '<em class="icon ni ni-video"></em>' : '<em class="icon ni ni-video-off"></em>'
  }

  /**
   * when video is off, show user avatar
   */
  toggleVideoEffect(userId, status)
  {
    if(!status)
    {
      document.querySelector(`#user-${userId}`).nextSibling.querySelector('.info-image').classList.remove('d-none')
    }
    else
    {
      document.querySelector(`#user-${userId}`).nextSibling.querySelector('.info-image').classList.add('d-none')
    }
  }
  
  /**
   * toggle audio on or off
   */
  toggleAudio(btn){
    let status = null
    if(this.callStream)
    {
      this.callStream.peerConnection.getLocalStreams()[0].getTracks()[0].enabled = !this.callStream.peerConnection.getLocalStreams()[0].getTracks()[0].enabled
      status = this.callStream.peerConnection.getLocalStreams()[0].getTracks()[0].enabled
    }
    else
    {
      this.streamMedia.getAudioTracks()[0].enabled = !this.streamMedia.getAudioTracks()[0].enabled
      status = this.streamMedia.getAudioTracks()[0].enabled
    }

    this.toggleAudioEffect(this.userId, status)
    this.socket.emit('toggle-mic', {
      userId: this.userId,
      meetingName: this.meetingName,
      status: status
    })

    btn.innerHTML = status ? '<em class="icon ni ni-mic"></em>' : '<em class="icon ni ni-mic-off"></em>'
  }

  /**
   * if audio off, mic icon on user will update to mic-off
   */
  toggleAudioEffect(userId, status)
  {
    if(!status)
    {
      document.querySelector(`#user-${userId}`).nextSibling.querySelector('.info-mic').innerHTML = '<em class="ni ni-mic-off"></em>'
    }
    else
    {
      document.querySelector(`#user-${userId}`).nextSibling.querySelector('.info-mic').innerHTML = '<em class="icon ni ni-mic"></em>'
    }
  }

  /**
   * show meeting info
   */
  toggleInfo(targetClass) {
    targetClass = `.${targetClass}-panel`
    $(".info-item").addClass('d-none')
    $(targetClass).removeClass('d-none')
    if(!$(".meeting-info").hasClass('show') || this.toggleInfoLastTarget == targetClass)
    {
      $(".meeting-info").toggleClass('show')
    }

    this.refreshParticipantLists()
    
    this.toggleInfoLastTarget = targetClass
  }

  refreshParticipantLists(){
    // generate participants lists
    let participantLists = ''
    this.meetingParticipants.forEach(participant => {
          participantLists += `
          <div class="user-card mb-1">
            <div class="user-avatar">
              <em class="icon ni ni-user-alt"></em>
            </div>
            <div class="user-info">
              <span class="lead-text ccap">${participant.userName}</span>
              <span class="sub-text ccap">${participant.participantType}</span>
            </div>
          </div>  
          `
    })

    $(".participant-panel > .info-description").html(participantLists)
  }

  pushNewMeetingMessage(data){
    // generate participants lists
    const message = `
    <div class="user-card mb-1">
      <div class="user-avatar">
        <em class="icon ni ni-user-alt"></em>
      </div>
      <div class="user-info">
        <span class="lead-text ccap">${data.name}</span>
        <span class="sub-text">${data.content}</span>
      </div>
    </div>`
    $(".chat-panel > .info-description").append(message)
  }

  async screenShare(btn){
    if(this.isScreenShared)
    {
      this.stopScreenShare(btn)
      return
    }
    const stream = await navigator.mediaDevices.getDisplayMedia({ video: true })
    const videoTrack = stream.getVideoTracks()[0];
    videoTrack.onended = fn => {
      this.stopScreenShare()
    }

    const ownVideoTrack = this.callStream.peerConnection.getSenders().find(function (s) {
      return s.track.kind == videoTrack.kind;
    })

    ownVideoTrack.replaceTrack(videoTrack)
    this.screenStream = stream
    this.isScreenShared = true
    btn.innerHTML = '<em class="icon ni ni-stop-circle"></em>'
  }

  async stopScreenShare(btn = false){
    if(btn)
    {
      btn.innerHTML = '<em class="icon ni ni-monitor"></em>'
    }
    this.isScreenShared = false
    let videoTrack = this.streamMedia.getVideoTracks()[0];

    let sender = this.callStream.peerConnection.getSenders().find(function (s) {
      return s.track.kind == videoTrack.kind;
    })

    sender.replaceTrack(videoTrack)

    this.screenStream.getTracks().forEach(function (track) {
        track.stop();
    });
  }

  /**
   * call status
   */
  updateCallFoot(status){
    $('.call-foot').html(this.callActionInterface(status))
  }

  /**
   * leave meeting function
   */
  leaveMeeting(){
    this.killMedia()
    this.socket.emit('leave-meeting',{userId:this.userId,meetingName:this.meetingName})
    setTimeout( e => {
      const elem = '.video-call-interface'
      $(elem).fadeOut(300, fn => {
        $(elem).remove()
        window.location.reload()
      })
    }, 2000)
  }

  /**
   * leave call group
   */
  leaveCallGroup(){
    this.killMedia()
    this.socket.emit('leave-call-group',{userId:this.userId,groupId:this.targetGroup.id})
    setTimeout( e => {
      const elem = '.video-call-interface, .call-interface'
      $(elem).fadeOut(300, fn => {
        $(elem).remove()
      })
    }, 2000)
  }

  /**
   * ended call function
   */
  endedCall(btn, text = 'Call Ended'){
    if(this.mode == 'meet')
    {
      this.leaveMeeting()
      return
    }

    if(this.mode == 'call group')
    {
      this.leaveCallGroup()
      if(btn)
      {
        $(btn).removeClass('btn-danger')
        $(btn).addClass('btn-light')
      }

      if(text.includes('Call Rejected'))
      {
        $('.btn-call-accept').hide()
      }
      return
    }
    this.socket.emit('call-ended', this.userId)
    this.killMedia()

    if(btn)
    {
      $(btn).removeClass('btn-danger')
      $(btn).addClass('btn-light')
    }

    if(text.includes('Call Rejected'))
    {
      $('.btn-call-accept').hide()
    }

    const elem = '.video-call-interface, .call-interface'
    this.targetContact = null
    this.targetGroup = null
    $('.call-body').html(text)
    setTimeout( e => {
      $(elem).fadeOut(300, fn => {
        $(elem).remove()
      })
    }, 2000)
  }

  /**
   * ended call function
   */
  rejectCallGroup(btn, text = 'Call Ended'){
    this.killMedia()

    if(btn)
    {
      $(btn).removeClass('btn-danger')
      $(btn).addClass('btn-light')
    }

    if(text.includes('Call Rejected'))
    {
      $('.btn-call-accept').hide()
    }

    const elem = '.video-call-interface, .call-interface'
    this.targetContact = null
    this.targetGroup = null
    $('.call-body').html(text)
    setTimeout( e => {
      $(elem).fadeOut(300, fn => {
        $(elem).remove()
      })
    }, 2000)
  }

  /**
   * call function
   * @params Collection targetContact
   * @params bool video
   */
  call(targetContact, video = false){
    this.targetContact = targetContact
    this.targetContact.video = video
    
    this.callInterface(`Waiting...`)

    this.socket.emit('call-user', {callerId:this.userId, targetId:targetContact.id, video: video}, async (response) => {
      // if user is not online
      if(!response.status.includes('ready'))
      {
        // send is busy message
        this.isBusyAction(response.status == 'busy' ? 'is busy. Call ended.' : response.status)
      }
      else
      {
        if(video)
        {
          // show video call interface with datetime
          this.videoCallInterface()
          this.runTime(response.datetime)
        }
        else
        {
          this.callInterface(`Calling...`)
        }

        // set and play calling audio
        if(process.env.MIX_CALL_AUDIO)
        {
          this.callingAudio.src = process.env.MIX_CALL_AUDIO
          this.callingAudio.play()
        }

        this.streamMedia = await navigator.mediaDevices.getUserMedia({
          video: video,
          audio: true
        })

        const user = await window.chatFunction.value.getContact()
    
        // append MediaStream to call interface
        this.appendStreamMedia(false, video, this.userId, {
          user: user.full_name,
          video: video,
          audio: true
        })
      }
    })
  }

  /**
   * callGroup function
   * @params Collection targetGroup
   * @params bool video
   */
  callGroup(targetGroup, video = false){
    this.title = targetGroup.name
    this.mode  = 'call group'
    this.targetGroup = targetGroup
    this.targetGroup.video = video

    this.meetingConstraints = {
      video: video,
      audio: true
    }
    
    const members = targetGroup.members.filter(member => member.member_id != this.userId).map(member => {
      return member.member_id
    })

    this.socket.emit('call-group', {
      callerId:this.userId, 
      targetId:targetGroup.id, 
      video: video,
      members: members
    }, async (response) => {
      // if no user is online
      if(!response.status.includes('ready'))
      {
        // send is busy message
        this.isBusyAction(response.status)
      }
      else
      {
        // show video call interface with datetime
        this.videoCallInterface()
        this.runTime(response.datetime)

        this.streamMedia = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true
        })

        this.streamMedia.getVideoTracks()[0].enabled = video

        const user = await window.chatFunction.value.getContact()
    
        // append MediaStream to call interface
        this.appendStreamMedia(false, true, this.userId, {
          user: user.full_name,
          video: video,
          audio: true
        })
      }
    })
  }

  /**
   * broadcast when user is typing
   */
  bcTyping(targetContact, status){
    this.targetContact = targetContact
    this.socket.emit('bc-typing', {callerId:this.userId, targetId:targetContact.id, status: status})
  }

  /**
   * broadcast when user send a message
   */
  bcMessage(targetContact, data)
  {
    this.targetContact = targetContact
    this.socket.emit('bc-message', {callerId:this.userId, targetId:targetContact.id, data:data})
  }

  /**
   * broadcast message to all user in same group
   */
  bcMessageGroup(targetGroup, data)
  {
    this.targetGroup = targetGroup
    const members = targetGroup.members.filter(member => member.member_id != this.userId).map(member => {
      return member.member_id
    })
    this.socket.emit('bc-message-group', {
      callerId:this.userId, 
      targetId:targetGroup.id,
      members: members, 
      data:data
    })
  }

  /**
   * is busy action to tell caller because user is busy
   */
  isBusyAction(text){
    this.killMedia()
    $('.call-body').html(`${this.targetContact.full_name} ${text}`)
    $('.btn-call-ended').html('Call ended')
    $('.btn-call-ended').removeClass('btn-danger')
    $('.btn-call-ended').addClass('btn-light')

    setTimeout( e => {
      $(".call-interface").fadeOut(300, fn => {
        $(".call-interface").remove()
      })
    }, 2000)
  }

  /**
   * accept call function when user click accept call button
   */
  async acceptCall(){
    $('.call-body').html('Waiting...')

    // stoping ringtone
    this.stopingAudio()
    const user = await window.chatFunction.value.getContact()
    let emitData = {callerId:null, targetId:this.userId}

    let constraints =  {
      user: user.full_name,
      video: false,
      audio: true
      // video: this.mode == 'call' ? this.targetContact.video : true,
    }
    let video = false
    if(this.mode == 'call')
    {
      // using video call interface
      if(this.targetContact.video)
      {
        this.videoCallInterface()
        video = true
        constraints.video = video
      }

      emitData.callerId = this.targetContact.id
    }
    else if(this.mode == 'call group')
    {
      emitData = {groupId:this.targetGroup.id, userName:user.full_name, callerId:this.targetGroup.callerId, targetId:this.userId}
      this.videoCallInterface()
      video = true
      constraints.video = this.targetGroup.video
    }

    this.streamMedia = await navigator.mediaDevices.getUserMedia({
      video: video,
      audio: true
    })

    this.streamMedia.getVideoTracks()[0].enabled = constraints.video

    // append our MediaStream to call interface
    this.appendStreamMedia(false, video, this.userId, constraints)

    // send signal to caller because we already accept the call
    this.socket.emit('answer-call', emitData, (data) => {
      this.runTime(data.datetime)
    })
  }

  /**
   * reject call function
   */
  rejectCall(btn){
    if(this.mode == 'call')
    {
      this.socket.emit('reject-call', this.targetContact.id)
      this.endedCall(btn, 'Call Rejected.')
    }
    else
    {
      this.socket.emit('reject-call-group', {groupId:this.targetGroup.id,userId:this.userId})
      this.rejectCallGroup(btn, 'Call Rejected.')
    }

  }

  /**
   * kill media function
   */
  killMedia(){
    $('.video-stream *').remove()

    this.stopingAudio()

    if(this.streamMedia)
    {
      this.streamMedia.getTracks().forEach( (track) => {
        track.stop();
      });
    }

    if(this.targetStreamMedia)
    {
      this.targetStreamMedia.getTracks().forEach( (track) => {
        track.stop();
      });
    }
  }

  /**
   * stoping audio function
   */
  stopingAudio(){
    clearTimeout(this.callingAudioTimeout)
    try {
      this.callingAudio.currentTime = 0;
      this.callingAudio.pause()
      // this.callingAudio.stop()
    } catch (error) {
    }
  }

  /**
   * append stream media function
   * to append given MediaStream into call interface
   */
  appendStreamMedia(stream, video = false, userId, data = false){
    if(document.querySelector(`#user-${userId}`)) return

    let media = document.createElement('video') 
    media.id = `user-${userId}`
    media.classList.add('user-video-element')
    if(!stream)
    {
      media.muted = true
      media.srcObject = this.streamMedia
    }
    else
    {
      media.srcObject = stream
    }

    media.addEventListener('loadedmetadata', () => { // Play the video as it loads
      media.play()
    })

    if(video)
    {
      // open video call interface
      let div = document.createElement('div')
      div.classList.add('user-video')
      div.classList.add('meeting')

      let userInfo = document.createElement('div')
      userInfo.classList.add('user-info','p-2')

      let infoImage = document.createElement('div')
      infoImage.classList.add('info-image','d-none','d-flex','align-items-center','justify-content-center')

      if(data && data.hasOwnProperty('video') && !data.video)
      {
        infoImage.classList.remove('d-none')
      }

      let image = document.createElement('img')
      image.classList.add('img-fluid')
      image.width = 100
      image.height = 100
      image.src = data.hasOwnProperty('image') ? data.image : '/modules/chat/img/logo-light.png'

      infoImage.appendChild(image)

      let infoName = document.createElement('div')
      infoName.classList.add('info-name','text-white')
      infoName.innerHTML = data.user
      
      let infoMic = document.createElement('div')
      infoMic.classList.add('info-mic','text-white')
      infoMic.innerHTML = '<em class="ni ni-mic"></em>'

      if(data && data.hasOwnProperty('audio') && !data.audio)
      {
        infoMic.innerHTML = '<em class="ni ni-mic-off"></em>'
      }

      userInfo.appendChild(infoMic)
      userInfo.appendChild(infoImage)
      userInfo.appendChild(infoName)

      div.appendChild(media)
      div.appendChild(userInfo)
      $('.vc-body').append(div)
    }
    else
    {
      media.style.height = '0px'
      media.style.overflow = 'hidden'
      $('.audio-stream').append(media)
    }
  }
  
  /**
   * show time in video call or meeting interface
   */
  runTime(givenTime){
    const date = new Date(parseInt(givenTime)*1000)
    const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    const dateString = hours + ':' + minutes
    $('.neo-clock').html(dateString)
    setTimeout(e => {
      this.runTime(givenTime+1)
    }, 1000)
  }
}